import axios from "axios";
import DataModule from "./DataModule";
import ModuleNetwork from "./ModuleNetwork";
import { routeConfig } from '../router/RouterMap'

let ICON_MAP = null;

class ModuleCenter {
    static _inst = null;
    static getInstance() {
        if (!ModuleCenter._inst) ModuleCenter._inst = new ModuleCenter();
        return ModuleCenter._inst;
    }

    static async loadStatusIcons() {
        try {
            const iconDatas = (await axios.get('/statusicons/icon-map.json')).data;
            const map = {};
            for (const {code, values} of iconDatas) {
                const vm = map[code] = {};
                for (const {value, icon, color} of values) {
                    vm[value] = {icon, color};
                }
            }
            ICON_MAP = map;
        } catch(e) {}
    }

    static addRefs() {
        ModuleCenter.getInstance().addRefs();
    }

    static registerModule(config) {
        return ModuleCenter.getInstance().registerModule(config.code, config, ICON_MAP ? ICON_MAP[config.code] || null : null);
    }
    static registerModules(configs) {
        return ModuleCenter.getInstance().registerModules(configs);
    }
    static getModule(code) {
        return ModuleCenter.getInstance().getModule(code);
    }
    static test(code, field) {
        return ModuleCenter.getInstance().test(code, field);
    }

    static setup() {
        ModuleCenter.getInstance().createModuleRelations();
        // ModuleCenter.getInstance().createTestDatas();
    }

    static testRelations(path) {
        return ModuleCenter.getInstance().testRelations(path);
    }
    static testModule(fromModule, toModule) {
        return ModuleCenter.getInstance().testModule(fromModule, toModule);
    }
    static checkDynamicRelation(fromModule, toModule, field) {
        return ModuleCenter.getInstance().checkDynamicRelation(fromModule, toModule, field);
    }

    _map = new Map();
    _network = new ModuleNetwork();

    constructor() {
    }

    registerModule(code, config, iconMap) {
        const module = new DataModule(code, config, null, iconMap);
        if (code) this._map.set(code, module);
        return module;
    }
    registerModules(configs) {
        const modules = [];
        for (const config of configs) {
            // console.log('regist module', config.code);
            modules.push(this.registerModule(config.code, config, ICON_MAP ? ICON_MAP[config.code] || null : null));
        }
        return modules;
    }

    getModule(code) {
        const module = this._map.get(code) || null;
        if (!module) {
            // throw new Error('module ' + code + ' is not exists.')
            // console.log('%cmodule ' + code + ' is not exists.', 'color:#F00')
        }
        return module;
    }
    
    addRefs() {
        for (const route of routeConfig) {
            if (route.refCode) {
                this._map.set(route.refCode, this._map.get(route.module));
            }
        }
    }

    test(code, field) {
        const module = this.getModule(code);
        if (!module) return null;
        if (!field) return module;
        const f = module.getDataField(field);
        return f ? {module:module, field:f} : null;
    }

    getDependTree() {
        const dependTree = {};
        const map = {};
        for (const [code, module] of this._map) {
            let node = map[code];
            if (!map[code]) node = map[code] = dependTree[code] = {};
            for (const field of module.getRelFields()) {
                const relInfo = field.getRelatedInfo();
                if (!relInfo) {
                    console.log('relation is not exists', code + '.' + field._code, '&', field._foreignField  );
                    continue;
                }
                const rCode = relInfo.module.getCode();
                let rDepend = map[rCode];
                if (!rDepend) rDepend = map[rCode] = {};
                node[rCode] = rDepend;
                if (dependTree[rCode]) delete dependTree[rCode];
            }
        }
        // console.log('depend tree', dependTree)
        return dependTree;
    }
    createDepTestDatas(depTree, map) {
        if (!map) map = {};
        for (const [code, depend] of Object.entries(depTree)) {
            // console.log('code',code)
            if (map[code]) continue;
            map[code] = 1;
            const module = this.getModule(code);
            this.createDepTestDatas(depend, map);
            module.createTestTable();
        }
    }
    createTestDatas() {
        this.createDepTestDatas(this.getDependTree());
    }

    createModuleRelations() {
        // console.log('module relation map', this._map);
        this._network.clearRelations();
        for (const [moduleCode, module] of this._map) {
            if(!module){
                console.log('-----------',this._map, moduleCode);
            }
            module.resetBindInfos();
            const foreignMap = module.getForeignMap();
            
            for (const [fCode, dataFields] of Object.entries(foreignMap)) {
                for (const dataField of dataFields) {
                    const relInfo = dataField.getRelatedInfo();
                    if (relInfo) this._network.addRelations(module.getCode(), dataField.getCode(), relInfo.module.getCode(), relInfo.field.getCode());
                    const dynamicRelInfo = dataField.getDynamicRelatedInfo();
                    if (dynamicRelInfo) {
                        for (const rInfo of dynamicRelInfo) {
                            this._network.addDynamicRelations(module.getCode(), dataField.getCode(), rInfo.module.getCode(), rInfo.field.getCode());
                        }
                    }
                }
            }
        }
    }

    testRelations(path) {
        return this._network.testRelations(path);
    }
    testModule(fromModule, toModule) {
        return this._network.testModule(fromModule, toModule);
    }

    checkDynamicRelation(fromModule, toModule, field) {
        const fModule = this._network._dynamicRelations[fromModule];
        if (!fModule) return false;
        const rels = fModule[toModule];
        if (!rels) return false;
        for (const {src} of rels.relations) {
            if (field == src) return true;
        }
        return false;
    }

    // static getFieldRelations(srcModule, srcField, destModule, destField) {
    //     const srcDataModule = srcModule instanceof DataModule ? srcModule : ModuleCenter.getModule(srcModule);
    //     const destDataModule = destModule instanceof DataModule ? destModule : ModuleCenter.getModule(destModule);

    // }
    // static getRelations(srcModule, destModule) {
    //     const srcDataModule = srcModule instanceof DataModule ? srcModule : ModuleCenter.getModule(srcModule);
    //     const destDataModule = destModule instanceof DataModule ? destModule : ModuleCenter.getModule(destModule);
    // }
}

export default ModuleCenter;